import { useEffect, useState } from "react";
import styles from "./ChatBubble.module.css";
import Callout from "../Callout/Callout";

interface ChatBubbleProps {
  onClick: () => void;
  imageURL: string;
  calloutMessage: string | null;
  enabledCallout: boolean;
}

const ChatBubble = ({ onClick, imageURL, calloutMessage, enabledCallout }: ChatBubbleProps) => {
  const [showCallout, setShowCallout] = useState(false);

  useEffect(() => {
    setShowCallout(true);
    const hideTimeout = setTimeout(() => {
      setShowCallout(false);
    }, 5000);

    return () => clearTimeout(hideTimeout);
  }, []);

  return (
    <div className={styles.wrapper}>
      {showCallout && enabledCallout && calloutMessage && (
        <Callout text={calloutMessage} />
      )}
      <button className={`${styles.bubble} ${styles.visible}`} id="chat-bubble-button" onClick={onClick} aria-label="Öppna chatt" aria-haspopup="dialog">
        <img src={imageURL} alt="Öppna chatt" className={styles.image} />
      </button>
    </div>
  );
};

export default ChatBubble;
